import * as Const from '../constants';
import State from '../interfaces/state/shareablePlaylistLinksState';

const initState: State = {
  list: [],
  isLoading: false,
  isError: false,
};

export default function shareablePlaylistLinks(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.SH_PLAYLIST_LINKS_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.SH_PLAYLIST_LINKS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case Const.SH_PLAYLIST_LINKS_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.SH_PLAYLIST_LINKS_RECEIVE:
      return {
        ...state,
        list: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.SH_PLAYLIST_LINKS_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.SH_PLAYLIST_LINKS_ADD_NEW:
      return {
        ...state,
        list: [...state.list, action.payload],
      };

    default:
      return state;
  }
}
